export default {
  'setOwner(address)': 'Set `$1` as the new owner',
  'setOwner(bytes32,address)': 'Set `$2` as the new owner of the `$1` node',
  'transfer(address,uint256)': 'Transfer `@tokenAmount(self, $2)` to `$1`',
  'payday()': 'Get owed Payroll allowance'
}
